import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Landing route for the Keycloak redirect (OIDC_REDIRECT_URI ->
 * https://<host>/oidc/callback). Exchanges the authorization code for
 * tokens, loads the profile and returns the user to where they started.
 */
const OidcCallbackPage: React.FC = () => {
  const { completeSsoLogin, loginWithSso } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  // React 18 StrictMode mounts effects twice in development; the code may
  // only be redeemed once, so guard the exchange.
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    completeSsoLogin(new URLSearchParams(window.location.search))
      .then((returnTo) => navigate(returnTo, { replace: true }))
      .catch((err: any) => setError(err.message || 'SSO-Anmeldung fehlgeschlagen'));
  }, [completeSsoLogin, navigate]);

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <p className="auth-brand">Intermal</p>
          <h2 className="auth-title">Anmeldung fehlgeschlagen</h2>
          <div className="alert alert-error">{error}</div>
          <button
            type="button"
            className="btn btn-primary btn-full"
            onClick={() => loginWithSso('/').catch((e: any) => setError(e.message))}
          >
            Erneut anmelden
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <p className="auth-brand">Intermal</p>
        <h2 className="auth-title">Anmeldung läuft...</h2>
        <p className="auth-subtitle">Einen Moment, das SSO-Token wird eingelöst.</p>
      </div>
    </div>
  );
};

export default OidcCallbackPage;
